import { FormBuilder, Validators } from '@angular/forms';
import { Examen } from '../Examen.config';
import { apellidoNombreTrabajadorValidator } from '../../../../../utils/apellido-nombre-trabajador-validator';

export class EstudioEvaluacionDermatologica extends Examen {
	id = 3;
	code = 'DERM';
	name = 'EVALUACION DERMATOLOGICA';
	baseUrl = 'estudios/carga';
	isAttachedFileRequire = false;
	sections = [
		{
			name: 'EVALUACION DERMATOLOGICA',
			fields: {
				fechaRealizacion: ['', [Validators.required]],
			},
		},
		{
			name: 'Empleador',
			fields: {},
			numberForm: 1,
		},
		{
			name: 'Trabajador',
			fields: {
				apellidoNombre:['', [Validators.required, Validators.maxLength(100), apellidoNombreTrabajadorValidator]],
        		fechaNacimiento: ['', [Validators.required]],   
				puestoTrabajador: ['', [Validators.required]],
				fechaIngresoEmpresa: ['', [Validators.required]],
				antiguedadPuestoTrabajador: ['', [Validators.required]],
			},
			numberForm: 2,
		},
		{
			name: 'HistorialLaboral',
			fields: {
				expAnt: [ false ],
				expAntSi: [ false ],
				expAntNo: [ true ],
				expAntDesc: [ { value: '', disabled: true } ],
				riesgo: [ { value: '', disabled: true } ],
				sustTrab: [ '' , [Validators.required] ],
				elemProt: [ false ],
				elemProtSi: [ false ],
				elemProtNo: [ true ],
				elemProtCual: [ { value: '', disabled: true } ]
			},
			numberForm: 3,
		},
		{
			name: 'HistorialDermatologico',
			fields: {
				antEnfDer: [ false ],
				antEnfDerSi: [ false ],
				antEnfDerNo: [ true ],
				antEnfDerCual: [ { value: '', disabled: true } ]
			},
			numberForm: 4,
		},
		{
			name: 'EstudioDermatologicoActual',
			fields: {
				lesion: [ false ],
				lesionSi: [ false ],
				lesionNo: [ true ],
				lesionLoc: [ { value: '', disabled: true } ],
				lesionExt: [ { value: '', disabled: true } ],
				lesionDesc: [ { value: '', disabled: true } ],
				restNorm: [ true ],
				restPat: [ false ],
				restDesc: [ { value: '', disabled: true } ]
			},
			numberForm: 5,
		},
		{
			name: 'Diagnostico',
			fields: {
				diagnosticoNormal: [ true ],
				dermatitisIrritativaContacto: [ false ],
				dermatitisAlergicaContacto: [ false ],
				eccema: [ false ],
				otros: [ false ],
				otrosDesc: [ { value: '', disabled: true } ]
			},
			numberForm: 6,
		},
		{
			name: 'Observaciones',
			fields: {
				conclusion: [ '', [Validators.required, Validators.maxLength(4000)] ]
			},
			numberForm: 7,
		},
		{
			name: 'Dictamen medico',
			fields: {
				medicoNombre: [ '', [ Validators.required, Validators.pattern( /^[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ\s]+$/ ), ] ],
				codigoDictamen: [ '', [ Validators.required ] ],
				medicoMatricula: ['', [Validators.required]],
				medicoEspecialidad: ['', [Validators.required]],
			},
			numberForm: 8,
		},
		{
			name: 'Adjuntos',
			fields: {},
			numberForm: 9,
		},
	];

	constructor(formBuilder: FormBuilder) {
		super(formBuilder);
		this.fieldList = this.getFields();
		this.examForm = this.getForm();
		this.sectionsList = this.getSections();
	}
}
